var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkforIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 351,
    viewBox: "0 0 351 351",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 175.5,
    r: 175.5,
    fill: "#ACC32A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_6286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.76 209.689C107.697 207.127 106.374 204.58 105.987 201.816C100.887 166.174 129.966 137.277 156.36 126.301C182.753 115.325 213.142 132.784 231.158 114.043C235.66 108.96 240.241 104.147 247.085 104.112C249.937 104.253 252.313 105.594 253.527 107.959C276.046 154.085 243.872 208.777 207.538 228.21C184.48 239.607 160.62 242.114 138.286 234.383C132.076 232.91 127.098 226.415 120.66 226.331C116.221 228.822 112.534 236.937 109.521 241.407C106.012 247.497 99.0247 249.107 93.9975 243.778C79.3344 229.328 109.807 216.502 108.76 209.689ZM128.355 203.784C131.504 206.328 136.047 205.607 138.465 203.068C157.801 179.64 183.984 169.362 212.459 170.142C216.655 170.386 219.705 166.988 219.974 163.342C220.059 159.013 216.727 156.085 212.995 155.827C178.58 153.914 148.722 169.089 127.639 193.584C124.969 196.919 125.453 201.355 128.355 203.784Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_6286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 171,
    height: 171,
    fill: "white",
    transform: "translate(90 90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkforIcon2);
export default __webpack_public_path__ + "static/media/workfor-icon2.521e00d984e7ff9bc15165f81d3cd34a.svg";
export { ForwardRef as ReactComponent };